import { render, staticRenderFns } from "./_onlyText.vue?vue&type=template&id=2c95f618&"
import script from "./_onlyText.vue?vue&type=script&lang=js&"
export * from "./_onlyText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports